import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import RuleForm from './RuleForm'
import { Edit } from 'react-admin'

const RuleEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <RuleForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default RuleEdit
